// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';



/**
 * 基础菜单
 */
import tasks from '@/views/tasks/tasks';
import goods from '@/views/goods/goods';
import orders from '@/views/orders/orders';
import configs from '@/views/configs/configs';
import audits from '@/views/audits/audits';

// 启用路由
Vue.use(Router);
// 导出路由
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/index',
    name: '首页',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [{
        path: '/tasks/tasks',
        name: '任务管理',
        component: tasks,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/goods/goods',
        name: '积分礼品',
        component: goods,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/orders/orders',
        name: '订单列表',
        component: orders,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/configs/configs',
        name: '奖励配置',
        component: configs,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/audits/audits',
        name: '打卡审核',
        component: audits,
        meta: {
          requireAuth: true
        }
      }
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js